<template>
  <div>
    <BaseLabel
      :title="route.meta.title ? route.meta.title : route.name?.toString()"
      :size="16"
    />
    <Breadcrumb v-bind="breadcrumb" class="text-sm" />
  </div>
</template>

<script setup lang="ts">
import { computed, type ComputedRef } from 'vue';
import { useRoute } from 'vue-router';

import type { MenuItem } from 'primevue/menuitem';

const route = useRoute();

const breadcrumb: ComputedRef<{ home: MenuItem; model: MenuItem[] }> = computed(
  () => {
    const crumbs: MenuItem[] = [];
    route.matched.forEach((e) => {
      if (e.meta.breadcrumb) {
        const label = e.meta.breadcrumb;
        crumbs.push({
          label,
          to: e.path,
          disabled: e.meta.breadcrumbDisabled ?? e.name === route.name,
        } as MenuItem);
      }
    });
    const home: MenuItem = crumbs.shift() ?? {};

    return { home, model: crumbs };
  },
);

defineExpose({ breadcrumb });
</script>

<style scoped>
nav.p-breadcrumb {
  @apply border-none bg-transparent p-0 my-1 text-xs;
}
</style>
